import { ContractResponseError } from "~/types/api-types";

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public errorData?: ContractResponseError & {
      errorId?: string;
    },
  ) {
    super(message);
    this.status = status;
  }

  static fromResponse = async (
    response: Response,
    fallbackMsg?: string,
  ): Promise<ApiError | null> => {
    if (response.ok) {
      return null;
    }
    const errorData = await response.json();
    return new ApiError(
      errorData.message || fallbackMsg,
      response.status,
      errorData,
    );
  };
}
